import {actions, ActionType} from './action';
import {
  createBasicReducerHandlers,
  createReducer,
  ReducerActionHelper,
} from '../../common/util/redux';
import {IEnterInfo, ILuckydrawReward, IResult} from '../type';

export interface IStateLuckydraw {
  luckydrawReward?: ILuckydrawReward;
  result?: IResult;
  enterInfo?: IEnterInfo;
}

const INITIAL_STATE: IStateLuckydraw = {
  luckydrawReward: undefined,
  result: undefined,
  enterInfo: undefined,
};

export default createReducer<
  IStateLuckydraw,
  ReducerActionHelper<typeof actions>
>(INITIAL_STATE, {
  ...createBasicReducerHandlers({
    setValueActionType: ActionType.SetValue,
    setPropertyValuesActionType: ActionType.SetPropertyValues,
    initializeAllType: ActionType.InitializeAll,
  }),
});
